import { ACCOUNT_AUTH_PROHIBITED, ACCOUNT_CLOSED } from '../const/conditions';
const getIsBankrupt = (conditions) => {
    return (!conditions.includes(ACCOUNT_AUTH_PROHIBITED) &&
        conditions.includes(ACCOUNT_CLOSED));
};
export default getIsBankrupt;
